import { render, staticRenderFns } from "./WHHyperlink.vue?vue&type=template&id=01f89996&"
import script from "./WHHyperlink.vue?vue&type=script&lang=js&"
export * from "./WHHyperlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports